// extracted by mini-css-extract-plugin
export default {"container":"aK-z","error":"bK-z","disabled":"cK-z","submit":"dK-z","option":"eK-z","success":"fK-z","failure":"gK-z"};